import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { CardHoldersProvider } from './team.context'
import { useIntl } from 'react-intl'

function Teams({ role }) {
  const navigate = useNavigate()
  const { formatMessage , locale } = useIntl()
  return (
    <CardHoldersProvider>
      <div dir={locale === 'ar' ? 'rtl' : 'ltr'} onClick={() => navigate(-1)} class='tw-flex tw-mb-4 tw-w-full tw-justify-start'>
          <span className='tw-cursor-pointer'>{formatMessage({ id: "Back" })}</span>
      </div>
      <Outlet />
    </CardHoldersProvider>
  )
}

export default Teams
